import { css, cva } from '@lastbrand/web-ui-styled-system/css'

// Panda twin of ProductInfoPrice.module.scss, trimmed to what the remaining leaves use —
// the price/caption cluster itself renders through the ProductPriceDS block.

export const priceWrapperMainCss = css({ display: 'block' })

export const priceWrapperMainValueCss = css({
  textStyle: 'body-18',
  display: 'flex',
  alignItems: 'center',
  // pin lg explicitly (`lg: undefined` would not reset the 22px base).
  fontSize: { base: '22px', lg: '18px' },
})

// Not layered on priceWrapperMainValueCss so its 12px size isn't overridden by that base's responsive rule.
export const priceWrapperMainValueRpOfferCss = css({
  display: 'flex',
  alignItems: 'center',
  textStyle: 'body-12',
  lineHeight: '24px',
  width: 'auto',
})

// cva variant merge is deterministic (variant overrides base) so textDecoration resolves cleanly.
export const priceWrapperMainValueRpDecorationRecipe = cva({
  base: { opacity: 1, color: 'mediumgray' },
  variants: { festival: { true: { textDecoration: 'none' }, false: { textDecoration: 'line-through' } } },
})

// Parity placeholder; no distinct legacy rule.
export const priceWrapperMainValueRpUpdatedDesignV2Css = css({})

export const priceWrapperMainValuePerservingTraditionalCss = css({
  color: 'mediumgray',
  textDecoration: 'line-through',
})

export const priceWrapperMainTextCss = css({
  textStyle: 'body-12',
  fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
  fontWeight: 400,
  opacity: 1,
  color: 'mediumgray',
})

export const priceWrapperMainTextNewDesignV2Css = css({
  color: 'mediumgray',
})

// Parity placeholder; no distinct legacy rule.
export const priceWrapperMainTextUpdatedDesignV2Css = css({})

export const priceWrapperMainTextRpCss = css({
  whiteSpace: 'nowrap',
})

export const priceWrapperMainMarginCss = css({ mt: 'space-4' })

export const priceWrapperTraditionalRetailInlineCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  mt: 'space-4',
})

// Tags rendered below the block for the double variant (the Figma widget has no tag
// slots there); matches the block's own tags-row spacing.
export const tagsRowCss = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-6',
  mt: 'space-4',
})

// cva variant merge is deterministic (variant overrides base) so the 3P override wins.
export const finalSaleChipRecipe = cva({
  base: {
    paddingBlock: 'space-4',
    paddingInline: 'space-8',
    '& span': {
      color: 'black',
      textAlign: 'center',
      textStyle: 'body-12',
      fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
      fontWeight: 400,
      display: 'block',
    },
  },
  variants: {
    thirdParty: {
      false: { backdropFilter: 'blur(2px)', background: 'paperwhite', ml: 'space-4' },
      true: {
        backdropFilter: 'blur(2.5px)',
        background: 'offwhite',
        ml: 0,
        textStyle: 'body-12',
        fontFamily: 'Grosa, ui-sans-serif, system-ui, sans-serif',
        fontWeight: 400,
      },
    },
  },
})

export const priceWrapperMainThirdPartyMsgCss = css({
  textStyle: 'body-12',
  lineHeight: '24px', // legacy 2.4rem
  color: 'mediumgray',
  fontWeight: 400,
  mt: 'space-4',
})

export const b2bFinalSaleTextWrapperCss = css({ height: 'fit-content' })
